import { render } from "./SystemSettingPage.vue?vue&type=template&id=b4e299a0&scoped=true"
import script from "./SystemSettingPage.vue?vue&type=script&lang=js"
export * from "./SystemSettingPage.vue?vue&type=script&lang=js"

import "./SystemSettingPage.vue?vue&type=style&index=0&id=b4e299a0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\t.chida\\Desktop\\hybrid_inventory_baroque\\hybrid_inventory_web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4e299a0"]])

export default __exports__